import type { AskDynamoMessage } from "~/api/askDynamo"

interface AskDynamoMessageListProps {
  messages: AskDynamoMessage[]
  sending?: boolean
}

export function AskDynamoMessageList({ messages, sending = false }: AskDynamoMessageListProps) {
  if (messages.length === 0 && !sending) return null

  return (
    <div className="mt-6 flex flex-col gap-3" aria-live="polite">
      {messages.map((message) => (
        <div
          key={message.id}
          className={`flex ${message.role === "user" ? "justify-end" : "justify-start"}`}
        >
          <div
            className={`max-w-[85%] rounded-2xl px-3.5 py-2.5 text-sm leading-relaxed ${
              message.role === "user"
                ? "bg-[var(--color-ask-dynamo)] text-white"
                : "border border-[var(--color-divider)] bg-white text-[var(--color-text-primary)]"
            }`}
          >
            {message.content}
          </div>
        </div>
      ))}

      {sending && (
        <div className="flex justify-start">
          <div
            className="rounded-2xl border border-[var(--color-divider)] bg-white px-3.5 py-2.5 text-sm text-[var(--color-text-secondary)]"
            aria-label="Ask Dynamo is thinking"
          >
            Thinking…
          </div>
        </div>
      )}
    </div>
  )
}
